<template>
  <gj-popover lazy placement="bottom" width="270" v-model="visible" @show="show">
    <el-form :model="form" ref="form" class="gj-form" label-width="70px" style="    display: flex;
    flex-direction: column;
    align-items: flex-end;">
      <el-form-item
        prop="yourPrice"
        label="原价"
        :rules="[
          { required: true, message: '请输入原价', trigger: 'blur' },
          $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数'),
        ]"
      >
        <gj-input :width="'200px'" v-model="form.yourPrice">
          <template slot="append">{{ row.currencySymbol }}</template>
        </gj-input>
      </el-form-item>
      <el-form-item
        label="优惠价"
        prop="salePrice"
        :rules="[$gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')]"
      >
        <gj-input :width="'200px'" v-model="form.salePrice">
          <template slot="append">{{ row.currencySymbol }}</template>
        </gj-input>
      </el-form-item>
      <el-form-item
        label="优惠日期"
        :rules="{
          validator: validateSaleRangeDate,
        }"
        prop="saleRangeDate"
      >
        <gj-date-picker
          v-model="form.saleRangeDate"
          :width="'200px'"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></gj-date-picker>
      </el-form-item>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false" style="border: 1px solid #1F6EEF;height:26px">取消</el-button>
        <el-button type="primary" size="mini" @click="confirm" v-loading="loading" style="height:26px">确定</el-button>
      </div>
    </el-form>
    <i class="el-icon-edit" slot="reference" :disabled="false"></i>
  </gj-popover>
</template>

<script>
import { editGoodPrice } from '@/api/sale';
import { formRuleMixin } from '../../../../../minxins';
import { convertToDate } from '@/utils/date.util';
export default {
  name: 'edit-good-price',
  mixins: [formRuleMixin],
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      validateSaleRangeDate: (rule, value, callback) => {
        if (
          this.form.salePrice &&
          (!Array.isArray(this.form.saleRangeDate) || this.form.saleRangeDate.length < 1)
        ) {
          callback(new Error('已填优惠价， 请输入优惠日期'));
        } else {
          callback();
        }
      },
      visible: false,
      loading: false,
      form: {
        salePrice: this.row.salePrice,
        yourPrice: this.row.yourPrice,
        saleRangeDate: [this.row.saleStartDate, this.row.saleEndDate],
      },
    };
  },
  methods: {
    // B08GKT75KG
    show() {
      this.form = {
        salePrice: this.row.salePrice,
        yourPrice: this.row.yourPrice,
        saleRangeDate: [this.row.saleStartDate ? this.row.saleStartDate : "" , this.row.saleEndDate ? this.row.saleEndDate:''],
      };
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            listingId: this.row.id,
            salePrice: this.form.salePrice,
            yourPrice: this.form.yourPrice,
          };
          if (Array.isArray(this.form.saleRangeDate) && this.form.saleRangeDate.length > 1) {
            params.saleStartDate = convertToDate(this.form.saleRangeDate[0]);
            params.saleEndDate = convertToDate(this.form.saleRangeDate[1]);
          }
          editGoodPrice(params)
            .then(() => {
              this.visible = false;
            })
            .complete(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
